import styled from "styled-components";
import { px2rem } from "../../utils/css";
import { Color } from "config/index";

interface ToastCommonProps {
	isMobile: boolean;
}
export const ToastWrapper = styled.div`
	position: fixed;
	z-index: 2;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: ${(props: ToastCommonProps) => (props.isMobile ? px2rem(315) : "590px")};
`;

export const Toast = styled.div`
	padding: ${(props) =>
		props.isMobile ? `${px2rem(30)} ${px2rem(12)} ${px2rem(12)}` : "30px 30px 20px"};
	background: #fff;
	position: relative;
	border-radius: ${(props: ToastCommonProps) => (props.isMobile ? px2rem(6) : "4px")};
`;

export const CloseBtn = styled.div`
	position: absolute;
	top: 14px;
	right: 15px;
	cursor: pointer;
	img {
		width: ${(props: ToastCommonProps) => (props.isMobile ? px2rem(13) : "13px")};
	}
`;

export const ToastMain = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const SuccessIcon = styled.div`
	margin-bottom: 20px;
	flex-grow: 0;
	text-align: center;
	width: ${(props: ToastCommonProps) => (props.isMobile ? px2rem(60) : "60px")};
	height: ${(props: ToastCommonProps) => (props.isMobile ? px2rem(60) : "60px")};
	img {
		width: inherit;
	}
`;

export const TitleText = styled.div`
	flex-grow: 0;
	height: 25px;
	line-height: 25px;
	text-align: center;
	font-size: 18px;
	font-family: Avenir-Heavy, Avenir;
	font-weight: 800;
	color: #333333;
	margin-bottom: 10px;
`;

export const ToastMessage = styled.div`
	flex-grow: 1;
	line-height: 19px;
	font-size: 14px;
	text-align: center;
	a {
		color: #333333;
		font-weight: 800;
	}
`;

export const OKBtn = styled.div`
	width: 100%;
	flex-grow: 0;
	display: flex;
	justify-content: center;
	margin-top: 20px;

	p {
		width: ${(props: ToastCommonProps) => (props.isMobile ? "100%" : "90px")};
		height: 36px;
		line-height: 36px;
		text-align: center;
		border-radius: 4px;
		font-size: 14px;
		font-family: Avenir-Heavy, Avenir;
		background: ${Color.Main};
		font-weight: 800;
		color: #ffffff;
		cursor: pointer;
	}
`;
